import {
  BodyText,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@postscript/components';

interface ConfirmModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  headerText?: string;
  bodyText?: string;
}

const ConfirmModal = ({
  isOpen,
  onCancel,
  onSubmit,
  headerText = 'Confirm Override',
  bodyText = 'You have unsaved campaign text changes. Choosing this template will override those.',
}: ConfirmModalProps): JSX.Element => (
  <Modal
    dismissOnBackdropClick={false}
    isOpen={isOpen}
    onCancel={onCancel}
    data-cy="confirm-modal"
  >
    <ModalHeader data-cy="confirm-modal-header">{headerText}</ModalHeader>
    <ModalBody>
      <BodyText size="small">{bodyText}</BodyText>
    </ModalBody>
    <ModalFooter>
      <Button
        onClick={onSubmit}
        variant="primary"
        data-testid="confirm-modal-yes"
      >
        Proceed
      </Button>
      <Button onClick={onCancel} variant="text" data-cy="confirm-modal-no">
        Cancel
      </Button>
    </ModalFooter>
  </Modal>
);

export default ConfirmModal;
